/* eslint-disable max-len */
import type { ChakraComponent } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'
import React from 'react'

export const UserIssueIcon: ChakraComponent<'svg', any> = (props) => (
  <chakra.svg
    width={'24px'}
    height={'24px'}
    viewBox={'0 0 24 24'}
    fill={'none'}
    {...props}
  >
    <path
      d={'M12.0001 10.8C13.9883 10.8 15.6001 9.1882 15.6001 7.19998C15.6001 5.21175 13.9883 3.59998 12.0001 3.59998C10.0119 3.59998 8.4001 5.21175 8.4001 7.19998C8.4001 9.1882 10.0119 10.8 12.0001 10.8Z'}
      fill={'#F4BC22'}
    />
    <path
      d={'M3.6001 21.6C3.6001 16.9608 7.36091 13.2 12.0001 13.2C16.6393 13.2 20.4001 16.9608 20.4001 21.6H3.6001Z'}
      fill={'#F4BC22'}
    />
  </chakra.svg>
)
